/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import { HealthBasicsValuesFragmentDoc } from './HealthBasics';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateHealthBasicsMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.UpdateHealthBasicsInput;
}>;


export type UpdateHealthBasicsMutation = { __typename?: 'Mutation', updateHealthBasics: { __typename?: 'UpdateHealthBasicsPayload', nextStepPath: string | null, form: { __typename?: 'HealthBasics', id: string, heightInInches: number | null, weight: number | null, historyOfTobaccoUse: boolean | null, usedInPastYear: boolean | null, planningToBeOrPregnant: boolean | null, suspendedConviction: boolean | null, dwiConviction: boolean | null, asthma: boolean | null, backProblems: boolean | null, basalCellSkinCancer: boolean | null, cancer: boolean | null, carpalTunnel: boolean | null, copd: boolean | null, depression: boolean | null, diabetes: boolean | null, emphysema: boolean | null, epilepsy: boolean | null, glaucoma: boolean | null, headachesOrMigraines: boolean | null, heartDisease: boolean | null, highBloodPressure: boolean | null, highCholesterol: boolean | null, kidneyOrLiverDisease: boolean | null, kneeInjuryOrSurgery: boolean | null, mentalIllness: boolean | null, otherSeriousMedicalConditions: boolean | null, rheumatoidArthritis: boolean | null, sleepApnea: boolean | null, stroke: boolean | null, ulcerativeColitisOrIleitis: boolean | null, vascularDisease: boolean | null, multipleSclerosis: boolean | null, alzheimerDisease: boolean | null, otherHealthIssues: string | null } } | null };


export const UpdateHealthBasicsDocument = gql`
    mutation UpdateHealthBasics($input: UpdateHealthBasicsInput!) {
  updateHealthBasics(input: $input) {
    form {
      id
      ...HealthBasicsValues
    }
    nextStepPath
  }
}
    ${HealthBasicsValuesFragmentDoc}`;
export type UpdateHealthBasicsMutationFn = Apollo.MutationFunction<UpdateHealthBasicsMutation, UpdateHealthBasicsMutationVariables>;
export function useUpdateHealthBasicsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHealthBasicsMutation, UpdateHealthBasicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHealthBasicsMutation, UpdateHealthBasicsMutationVariables>(UpdateHealthBasicsDocument, options);
      }
export type UpdateHealthBasicsMutationHookResult = ReturnType<typeof useUpdateHealthBasicsMutation>;
export type UpdateHealthBasicsMutationResult = Apollo.MutationResult<UpdateHealthBasicsMutation>;
export type UpdateHealthBasicsMutationOptions = Apollo.BaseMutationOptions<UpdateHealthBasicsMutation, UpdateHealthBasicsMutationVariables>;